import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateWorkflowDto } from '../dtos/create-workflow-dto.interface';
import { UpdateWorkflowDto } from '../dtos/update-workflow-dto.interface';
import { WorkflowDto } from '../dtos/workflow-dto.interface';
import { WorkflowsFilter } from '../interfaces/workflows-filter.interface';

export const WorkflowsActions = createActionGroup({
    source: 'Workflows',
    events: {
        'Load Workflows': props<{ filter?: WorkflowsFilter }>(),
        'Workflows Loaded': props<{ response: WorkflowDto[] }>(),
        'Workflows Load Failure': props<{ error: HttpErrorResponse }>(),

        // REV-22155 — loads the person template (created on first use) and merges it into the store.
        'Load Person Mandate Management Workflow': emptyProps(),
        'Person Mandate Management Workflow Loaded': props<{ response: WorkflowDto[] }>(),
        'Person Mandate Management Workflow Load Failure': props<{ error: HttpErrorResponse }>(),

        'Load Workflow By Id': props<{ workflowId: string }>(),
        'Workflow By Id Loaded': props<{ response: WorkflowDto }>(),
        'Workflow By Id Load Failure': props<{ error: HttpErrorResponse }>(),

        'Create Workflow': props<{ createWorkflowDto: CreateWorkflowDto }>(),
        'Workflow Created': props<{ response: WorkflowDto }>(),
        'Workflow Create Failure': props<{ error: HttpErrorResponse }>(),

        'Update Workflow': props<{ workflowId: string; updateWorkflowDto: UpdateWorkflowDto }>(),
        'Workflow Updated': props<{ response: WorkflowDto }>(),
        'Workflow Update Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Workflow': props<{ workflowId: string }>(),
        'Workflow Deleted': props<{ workflowId: string }>(),
        'Workflow Delete Failure': props<{ error: HttpErrorResponse }>(),

        'Set Selected Workflow ID': props<{ workflowId: string }>(),

        'Set Selected Workflow As Template Id': props<{ workflowId: string | null }>(),
    },
});
